import ContentBadge from './contentBadge';
import ContentHeading from './contentHeading';
import ContentSubHeading from './contentSubHeading';
import ContentTags from './contentTags';
import ContentActionButton from './contentActionButton';
import HeroImage from './heroImage';

const Content = () => {
  return (
    <div className="flex flex-col items-center gap-10 sm:gap-[60px] w-full max-w-[1120px] mx-auto">
      <div className="flex flex-col items-center gap-5 sm:gap-10 w-full">
        <ContentBadge text="Renaissance Plus" />
        <div className="flex flex-col items-center gap-2 sm:gap-5 w-full">
          <ContentHeading />
          <ContentSubHeading />
        </div>
      </div>
      <ContentActionButton />
      <div className="flex flex-col items-center gap-3 sm:gap-4 w-full">
        <ContentTags />
        <HeroImage />
      </div>
    </div>
  );
};

export default Content;
